"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    trVariants: ()=>trVariants
});
const tv_cjs_namespaceObject = require("../../../variants/tv.cjs");
const trVariants = (0, tv_cjs_namespaceObject.tv)({
    base: 'bg-neutral-1',
    variants: {
        striped: {
            true: 'even:bg-neutral-3 hover:text-neutral-11 hover:bg-neutral-4 active:bg-primary-3'
        },
        sticky: {
            true: 'border-b-1 border-primary-5',
            false: ''
        },
        tableBordered: {
            true: '',
            false: ''
        },
        isHeaderRow: {
            true: '',
            false: ''
        },
        color: {
            none: '',
            success: 'bg-success-3 hover:bg-success-4 active:bg-primary-3',
            error: 'bg-error-3 hover:bg-error-4 active:bg-primary-3',
            neutral: 'bg-neutral-3 hover:bg-neutral-4 active:bg-primary-3',
            caution: 'bg-caution-3 hover:bg-caution-4 active:bg-primary-3'
        }
    },
    compoundVariants: [
        {
            striped: false,
            tableBordered: true,
            isHeaderRow: false,
            class: 'nth-last-1:*:border-b-0'
        },
        {
            striped: false,
            isHeaderRow: false,
            color: 'none',
            class: 'hover:bg-neutral-2 active:bg-primary-3'
        }
    ],
    defaultVariants: {
        tableBordered: false,
        sticky: false,
        striped: false,
        isHeaderRow: false,
        color: 'none',
        isGroupHeader: false
    }
});
exports.trVariants = __webpack_exports__.trVariants;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "trVariants"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
